import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShowFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 5.54C16.48 5.54 19.84 9.06 21.76 11.96C19.84 14.86 16.48 18.38 12 18.38C7.52 18.38 4.16 14.86 2.24 11.96C4.16 9.06 7.52 5.54 12 5.54ZM12 14.48C13.38 14.48 14.52 13.34 14.52 11.96C14.52 10.58 13.38 9.44 12 9.44C10.62 9.44 9.48 10.58 9.48 11.96C9.48 13.34 10.62 14.48 12 14.48Z" />
    </SvgIcon>
  );
});
